import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { InputText } from 'primereact/inputtext';
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { Column } from 'primereact/column';
import { Editor } from 'primereact/editor';
import { toast } from "react-toastify";
import { Button, Col, Form, Row, Spinner } from "react-bootstrap"

import { HiOutlineArrowCircleLeft } from "react-icons/hi";
import { FaRegTrashAlt } from "react-icons/fa";
import { MdAdd } from "react-icons/md";

import { getNotificationDetails, updateNotifications, sendTestMail } from "../../../../../../services/manager/admin/settings.service";
import { ICommonComponent } from "../../models/commonComponent";

interface INotificationDetails extends ICommonComponent { 
  id?: any,
  back?: any
}

export const NotificationDetails: React.FC<INotificationDetails> = ({id, back, isLoading = true}) => {
  const { t: translation } = useTranslation();

  const [loading, setLoading] = useState<boolean>(true);
  const [loadingButton, setLoadingButton] = useState<boolean>(false);
  const [loadingMailTest, setLoadingMailTest] = useState<boolean>(false);
  const [isActive, setIsActive] = useState<boolean>(false);
  const [countAddEmail, setCountAddEmail] = useState<number>(-1);
  const [dateSelected, setDateSelected] = useState<number>(0);
  const [notification, setNotification] = useState<any>();
  const [emailsCopy, setEmailsCopy] = useState<any>([]);
  const [emailMessage, setEmailMessage] = useState("");
  const [emailTest, setEmailTest] = useState("");

  const dateOptions = [
    {label: "15", value: 15},
    {label: "30", value: 30},
    {label: "45", value: 45},
  ]

  const statusOptions = [
    {label: "Inativo", value: false},
    {label: "Ativo", value: true},
  ]

  const textEditor = (options: any) => {
    return <InputText type="text" className="w-100" value={options.value} onChange={(e) => options.editorCallback(e.target.value)} />;
  }

  const selectEditor = (options: any) => {
    return <Dropdown
      className="w-100"
      value={options.value}
      options={statusOptions}
      onChange={(e) => {
        options.editorCallback(e.target.value)
      }}
    />;
  }

  const addNemEmail = () => {
    setCountAddEmail(countAddEmail - 1)
    let arr = [...emailsCopy];
    arr.push({
      id: countAddEmail,
      title: "",
      email: "",
      is_active: false
    })
    setEmailsCopy(arr);
  }

  const handleRemoveEmailCopy = (node: any) => {
    let arr = [...emailsCopy];
    arr = arr.filter(e => e.id !== node.id)

    setEmailsCopy(arr);
  }

  const onEditEmailCopy = (e: any) => {
    let _emailsCopy = [...emailsCopy];
    let { newData, index } = e;

    _emailsCopy[index] = newData;

    setEmailsCopy(_emailsCopy);
  }

  const handleUpdateNotification = () => {
    setLoadingButton(true);
    let obj = {
      body: emailMessage,
      is_active: isActive,
      notification_day: dateSelected,
      emails_copy: emailsCopy
    }

    updateNotifications(id, obj).then(() => {
      toast.success("Notificação atualizada com sucesso!")
      setLoadingButton(false);
    }).catch(() => {
      toast.error("Ocorreu um erro ao atualizar a notificação. Tente novamente.")
      setLoadingButton(false);
    })
  }

  const sendMailTest = () => {
    setLoadingMailTest(true)
    let obj = {
      email: emailTest
    }
    
    sendTestMail(id, obj).then(() => {
      toast.success("E-mail de teste enviado com sucesso!")
      setLoadingMailTest(false)
    }).catch(() => {
      toast.error("Ocorreu um erro ao enviar o e-mail de teste. Tente novamente.")
      setLoadingMailTest(false)
    })
  }

  function statusTemplate(node: any) {
    return node.is_active ? "Ativo" : "Inativo"
  }

  function actionsTemplate(node: any) {
    return (
      <button className="p-row-editor-init" onClick={() => handleRemoveEmailCopy(node)}>
        <FaRegTrashAlt size="17"/>
      </button>
    )
  }

  useEffect(() => {
    getNotificationDetails(id).then((resp: any) => {
      setNotification(resp)
      setIsActive(resp.is_active)
      setDateSelected(resp.notification_day)
      setEmailMessage(resp.body)
      setEmailsCopy(resp.emails_copy)
      setEmailTest(resp.email_test)
    }).finally(() => {
      setLoading(false)
    })
  }, [])

  if (loading && isLoading) {
    return (
      <div className="loading-container">
        <Spinner animation="border" variant="primary" />
      </div>
    )
  }

  return (
    <Row className="ml-2 mt-3 mr-4">
      <Col md={6} className="mt-3 text-darker-grey">
        <HiOutlineArrowCircleLeft className="cursor-pointer mr-3 mb-1" size="25" 
          onClick={() => {
            back(false);
          }} 
        /> 
        <span style={{ fontSize: '20px' }}><b>{notification?.title}</b></span>
      </Col>
      <Col md={6} className="text-end mb-3 mt-3">
        {
          loadingButton ? (
            <Spinner animation="border" variant="primary" style={{ width: '2rem', height: '2rem', borderWidth: '0.25em', borderRightColor: 'transparent' }} />
          ) : (
            <Button onClick={() => handleUpdateNotification()}>{translation('manager.settings.save')}</Button>
          )
        }
      </Col>

      <Col xs={12} className="mb-4">
        <p className="font-light text-darker-grey">Configure uma mensagem automática que será enviada aos usuários quando o plano estiver próximo do vencimento.</p>
      </Col>

      <Row className="mb-4">
        <Col xs={8}>
          <p className="font-14 text-darker-grey mb-1">Ativar notificação por e-mail</p>
          <p className="font-14 font-light text-dark-grey">Ao ativar a opção acima o e-mail configurado será enviado a todos os usuário conforme a data da notificação. Caso nenhum e-mail seja configurado enviaremos um e-mail padrão.</p>
        </Col>
        <Col xs={4} className="d-flex justify-content-end">
          <Form.Check
            type="switch"
            checked={isActive}
            onChange={() => setIsActive(!isActive)}
          />
        </Col>
      </Row>

      <Row className="mb-4">
        <Col xs={12} md={8} lg={10}>
          <p className="font-14 text-darker-grey mb-1">Data da notificação</p>
          <p className="font-14 font-light text-dark-grey">Selecione quantos dias antes do vencimento deseja enviar o e-mail.</p>
        </Col>
        <Col xs={12} md={4} lg={2} className="d-flex justify-content-end align-items-center">
          <Dropdown
            className="w-100 select-form-default"
            value={dateSelected}
            options={dateOptions}
            onChange={(e) => {
              setDateSelected(e.value)
            }} 
            placeholder="Selecione a data de notificação em dias"
          />
        </Col>
      </Row>

      <Row className="mb-4">
        <Col xs={12}>
          <p className="font-14 text-darker-grey mb-1">Mensagem no e-mail</p>
          <p className="font-14 font-light text-dark-grey">As informações entre colchetes são preechidas automaticamente pelo sistema. Utilize as palavras [nome_usuario] e [n_dias] para que o sistema insira o nome do usuário e a quantidade de dias inserida anteriormente.</p>
        </Col>
        <Col xs={12}>
          <Editor style={{ height: '320px' }} value={emailMessage} onTextChange={(e: any) => setEmailMessage(e.htmlValue)}/>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col xs={12} md={6}>
          <p className="font-14 text-darker-grey mb-1">Em cópia</p>
          <p className="font-14 font-light text-dark-grey">Insira o e-mail que deseja receber a notificação em cópia.</p>
        </Col>
        <Col xs={12} md={6} className="d-flex justify-content-end align-items-center">
          <Button variant="outline-primary" onClick={() => addNemEmail()}>Adicionar e-mail <MdAdd/></Button>
        </Col>
        <Col xs={12}>
          <DataTable emptyMessage="Nenhum resultado encontrado" value={emailsCopy} editMode="row" dataKey="id" onRowEditComplete={onEditEmailCopy} responsiveLayout="scroll">
            <Column field="title" header="Título" editor={(options) => textEditor(options)} style={{ width: '20%' }}></Column>
            <Column field="email" header="E-mail" editor={(options) => textEditor(options)} style={{ width: '20%' }}></Column>
            <Column field="is_active" header="Status" body={statusTemplate} editor={(options) => selectEditor(options)} style={{ width: '20%' }}></Column>
            <Column rowEditor headerStyle={{ width: '15%' }} bodyStyle={{ textAlign: 'right' }}></Column>
            <Column body={actionsTemplate} headerStyle={{ width: '5%' }} bodyStyle={{ textAlign: 'left' }}></Column>
          </DataTable>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col xs={12}>
          <p className="font-14 text-darker-grey mb-1">E-mail teste</p>
          <p className="font-14 font-light text-dark-grey">Insira o endereço que deseja utilizar para receber o e-mail de teste.</p>
        </Col>

        <Col xs={12} md={8} className="mb-3">
          <InputText type="email" value={emailTest} onChange={(e: any) => setEmailTest(e.target.value)} className="w-100" style={{ height: '40px'}} />
        </Col>

        <Col xs={12} md={4} className="d-flex justify-content-end align-items-center mb-3">
          {
            loadingMailTest ? (
              <Spinner animation="border" variant="primary" style={{ width: '2rem', height: '2rem', borderWidth: '0.25em', borderRightColor: 'transparent' }} />
            ) : (
              <Button variant="outline-primary" onClick={() => sendMailTest()}>Enviar e-mail teste</Button>
            )
          }
        </Col>

        <Col xs={12} className="d-flex justify-content-end align-items-center">
          {
            loadingButton ? (
              <Spinner animation="border" variant="primary" style={{ width: '2rem', height: '2rem', borderWidth: '0.25em', borderRightColor: 'transparent' }} />
            ) : (
              <Button onClick={() => handleUpdateNotification()}>
                <span className="ml-1 mr-1">{translation('manager.settings.save')}</span>
              </Button>
            )
          }
        </Col>
      </Row>
    </Row>
  )
}